/* esm.sh - esbuild bundle(@internetarchive/ia-styles@1.0.0) esnext production */
import{css as r}from"/v135/lit@2.8.0/esnext/lit.mjs";var i=r`var(--white, #fff)`,e=r`var(--ia-theme-link-color, #4b64ff)`,l=r`var(--primaryDisableCTAFill, #767676)`,c=r`var(--secondaryCTABorder, #999)`,d=r`var(--primaryCTAFill, #194880)`,o=r`var(--primaryCTAFillRGB, 25, 72, 128)`,s=r`var(--primaryCTABorder, #c5d1df)`,b=r`var(--primaryErrorCTAFill, #d9534f)`,t=r`var(--primaryErrorCTAFillRGB, 229, 28, 38)`,u=r`var(--primaryErrorCTABorder, #d43f3a)`,p=r`var(--secondaryCTAFill, #333)`,a=r`var(--secondaryCTAFillRGB, 51, 51, 51)`,g=r`var(--primaryCTABorder, #979797)`,m=r`var(---primaryWarningFill, #ee8950)`,n=r`var(--primaryWarningFillRGB, 238, 137, 80)`,v=r`var(--primaryWarningBorder, #ec7939)`,B=r`
  .ia-button {
    min-height: 3rem;
    cursor: pointer;
    color: ${i};
    line-height: normal;
    border-radius: 0.4rem;
    font-size: 1.4rem;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    border: 1px solid transparent;
    white-space: nowrap;
    appearance: auto;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    transition: all 0.1s ease 0s;
    vertical-align: middle;
    padding: 0 3rem;
    outline-color: ${i};
    outline-offset: -4px;
    user-select: none;
    text-decoration: none;
    width: fit-content;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
  }
  .ia-button:focus-visible {
    outline-style: double;
  }
  .ia-button:disabled {
    cursor: not-allowed;
    background-color: ${l};
    border: 1px solid ${c};
  }
  .ia-button.transparent {
    background-color: transparent;
  }

  .ia-button.primary:disabled,
  .ia-button.danger:disabled,
  .ia-button.warning:disabled,
  .ia-button.dark:disabled {
    opacity: 0.5;
  }

  .ia-button.primary {
    background-color: ${d};
    border-color: ${s};
  }
  .ia-button.primary:hover {
    background-color: rgba(${o}, 0.9);
  }
  .ia-button.primary:focus-visible {
    background-color: rgba(${o}, 0.8);
  }
  .ia-button.primary:active {
    background-color: rgba(${o}, 0.7);
  }

  .ia-button.danger {
    background-color: ${b};
    border-color: ${u};
  }
  .ia-button.danger:hover {
    background-color: rgba(${t}, 0.9);
  }
  .ia-button.danger:focus-visible {
    background-color: rgba(${t}, 0.8);
  }
  .ia-button.danger:active {
    background-color: rgba(${t}, 0.7);
  }

  .ia-button.warning {
    background-color: ${m};
    border-color: ${v};
  }
  .ia-button.warning:hover {
    background-color: rgba(${n}, 0.9);
  }
  .ia-button.warning:focus-visible {
    background-color: rgba(${n}, 0.8);
  }
  .ia-button.warning:active {
    background-color: rgba(${n}, 0.7);
  }

  .ia-button.dark {
    background-color: ${p};
    border-color: ${g};
  }
  .ia-button.dark:hover {
    background-color: rgba(${a}, 0.9);
  }
  .ia-button.dark:focus-visible {
    background-color: rgba(${a}, 0.8);
  }
  .ia-button.dark:active {
    background-color: rgba(${a}, 0.7);
  }

  .ia-button.link {
    margin: 0;
    padding: 6px;
    border: 0;
    appearance: none;
    background: none;
    color: ${e};
    text-decoration: none;
    cursor: pointer;
  }
  .ia-button.link:hover {
    text-decoration: underline;
  }
`;import{css as k}from"/v135/lit@2.8.0/esnext/lit.mjs";var y=k`
  .sr-only {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    margin: -1px !important;
    padding: 0 !important;
    border: 0 !important;
    overflow: hidden !important;
    white-space: nowrap !important;
    clip: rect(1px, 1px, 1px, 1px) !important;
    -webkit-clip-path: inset(50%) !important;
    clip-path: inset(50%) !important;
    user-select: none !important;
  }
`;export{B as iaButtonStyles,y as iaSronlyStyles};
//# sourceMappingURL=ia-styles.mjs.map